<template>
  <div
    class="wizard-container shadow"
    :style="{
      marginTop: $route.params.id === 'datapeople-anywhere' ? '0px' : '100px',
      ...style,
    }"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'WizardContainer',
  props: {
    width: {
      type: String,
      default: '480px',
    },
    height: {
      type: String,
      default: 'auto',
    },
  },
  computed: {
    style() {
      const { width, height } = this;
      return { width, minHeight: height };
    },
  },
};
</script>

<style scoped lang="less">
.wizard-container {
  position: relative;
  margin-top: 100px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 100px;
  background-color: @white;
  border-radius: 12px;
}
</style>
